var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.changePage}},[_vm._v("新增消息模板")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }